/*
 * Website: https://www.4myth.com
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Copyright © 2016-2022 All rights reserved.
 * MyTh Ahmed Fayez
 */

export default {
  loginSubtitle: 'Welcome back',
  forgetPassword: 'Forget password ?',
  no_account: 'No account? ',
  create_account: 'Create new account'
}
